import axios from "axios";
import store from "@/store";

// service 循環遍歷輸出不同的請求方法
const Http = axios.create({
    timeout: 10000
});

// 攔截器的添加
// 請求攔截器
Http.interceptors.request.use(
    (config) => {
        // 發起請求前做些什麼
        store.commit("setLoading", true);
        return config;
    },
    (error) => {
        // 請求錯誤
        store.commit("setLoading", false);
        return Promise.reject(error);
    }
);

// 響應攔截器
Http.interceptors.response.use(
    (res) => {
        // 請求成功
        store.commit("setLoading", false);
        return res;
    },
    (error) => {
        // 響應錯誤
        store.commit("setLoading", false);
        return Promise.reject(error);
    }
);

export default Http;
